import React, { useRef, useState, useEffect } from "react";
import { useTransformContext } from "react-zoom-pan-pinch";
import { useMapEditor } from "../../Contexts/Context_MapEditor";
import { useMapRenderer } from "../../Contexts/Context_MapRenderer";

export default function Element_Map_Editor_Marker({
    id,
    x,
    y,
    Label_Room,
    Label_State,
    State,
    onSave,
    className = "Element_Map_Marker"
}) {
    const markerRef = useRef(null);
    const dragInfo = useRef(null);
    const { state } = useTransformContext(); // { scale, positionX, positionY, ... }
    const [scale, scale_set] = useState(1);
    const [posX, posX_set] = useState(0);
    const [posY, posY_set] = useState(0);
    const { Map_MovableMarkers } = useMapEditor();
    const { Map_HighlightedMarker, Room_Highlight, Room_Center, Information_Display } = useMapRenderer();
    // let scale = state?.scale ?? 1;
    // let posX = state?.positionX ?? 0;
    // let posY = state?.positionY ?? 0;

    useEffect(() => {
        scale_set(state?.scale ?? 1);
        posX_set(state?.positionX ?? 0);
        posY_set(state?.positionY ?? 0);
        // scale = state?.scale ?? 1;
        // console.warn(scale);
        // posX = state?.positionX ?? 0;
        // posY = state?.positionY ?? 0;
    }, [state])

    // marker map-space position (top-left) — keep in sync with props if externally updated
    const [pos, setPos] = useState({ x: Number(x) || 0, y: Number(y) || 0 });
    useEffect(() => setPos({ x: Number(x) || 0, y: Number(y) || 0 }), [x, y]);

    // helper: find the nearest transformed container (the element that TransformComponent transforms)
    function getTransformedContainer() {
        // This assumes Render_Map root (or similar) is the transformed element; adjust selector if different.
        return markerRef.current?.closest(".Renderer_Map") || document.querySelector(".Renderer_Map");
    }

    function screenToMap(clientX, clientY, containerRect, scale, posX, posY) {
        // clientX/Y are screen coords
        // containerRect is bounding rect of the transformed container (getBoundingClientRect())
        // posX/posY are transform translations from react-zoom-pan-pinch (px)
        // scale is current transform scale
        const mapX = (clientX - containerRect.left - posX) / scale;
        const mapY = (clientY - containerRect.top - posY) / scale;
        return { mapX, mapY };
    }

    function onPointerDownCapture(e) {
        if (!Map_MovableMarkers) return;
        if (e.button !== 0) return; // only left-button drag
        // prevent parent panning
        e.stopPropagation();
        e.preventDefault();

        const container = getTransformedContainer();
        if (!container) return;

        const rect = container.getBoundingClientRect();
        const { mapX, mapY } = screenToMap(e.clientX, e.clientY, rect, scale, posX, posY);

        // offset between pointer map coords and current marker map pos
        const offsetX = mapX - pos.x;
        const offsetY = mapY - pos.y;

        dragInfo.current = {
            pointerId: e.pointerId,
            offsetX,
            offsetY
        };

        try { markerRef.current.setPointerCapture(e.pointerId); } catch (_) { }
        markerRef.current.style.cursor = "grabbing";
    }

    function onPointerMove(e, id) {
        if (!dragInfo.current) return;
        // prevent parent panning
        e.stopPropagation();
        e.preventDefault();

        const container = getTransformedContainer();
        if (!container) return;
        const rect = container.getBoundingClientRect();
        const { mapX, mapY } = screenToMap(e.clientX, e.clientY, rect, scale, posX, posY);

        let newX = mapX - dragInfo.current.offsetX;
        let newY = mapY - dragInfo.current.offsetY;

        newX = Math.max(0, Math.min(950, newX));
        newY = Math.max(0, Math.min(950, newY));

        newX = Math.round(newX / 5) * 5;
        newY = Math.round(newY / 5) * 5;

        setPos({ x: newX, y: newY });
        // Room_Center(id, 400)
        
    }

    async function onPointerUp(e) {
        if (!dragInfo.current) return;
        try {
            e.stopPropagation();
            e.preventDefault();
        } catch (_) { }
        try { markerRef.current.releasePointerCapture(dragInfo.current.pointerId); } catch (_) { }
        markerRef.current.style.cursor = "grab";

        const finalX = Math.round(pos.x);
        const finalY = Math.round(pos.y);

        // call single save on pointerup
        if (onSave) {
            try { await onSave(id, finalX, finalY); } catch (err) { console.error("save failed", err); }
        }
        dragInfo.current = null;
    }

    function onPointerCancel(e) {
        dragInfo.current = null;
        try { markerRef.current.releasePointerCapture(e.pointerId); } catch (_) { }
        markerRef.current.style.cursor = "grab";
    }

    function handleHighlight(ID) {
        if (Map_MovableMarkers) { return; }
        Room_Highlight(ID, 4, 400);
        Information_Display("Room", ID);
    }

    return (
        <button
            ref={markerRef}
            id={id}
            className={className}
            State={State}
            style={{
                position: "absolute",
                left: `${pos.x}px`,
                top: `${pos.y}px`,
                touchAction: "none",
                cursor: "grab",
                zIndex: 50
            }}
            Selected={Map_HighlightedMarker == id ? "Selected" : null}
            onPointerDownCapture={onPointerDownCapture}
            onPointerMove={(e) => { onPointerMove(e, id);}}
            onPointerUp={onPointerUp}
            onPointerCancel={onPointerCancel}
            onLostPointerCapture={onPointerCancel}
            onClick={() => {
                handleHighlight(id)
            }}
        >
            <p className="Element_Map_Marker_Label">{Label_Room}</p>
            <p className="Element_Map_Marker_State">{pos.x}:{pos.y}</p>
        </button>
    );
}
